<template>
  <div>
    <!-- 客户售卖平台设置 -->
    <el-dialog :title="$t('message.customerSalesPlatformSetting')" :visible.sync="dialogVisible" width="760px" center
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="table">
        <ol>
          <!-- 客户售卖平台 -->
          <li class="flex2">
            {{ $t("message.customerSalesPlatform") }}
          </li>
          <!-- 售卖店铺信息截图 -->
          <li>{{ $t("message.screenshotOfSellingStoreInformation") }}</li>
          <!-- 操作 -->
          <li>{{ $t("message.operation") }}</li>
        </ol>
        <ul v-for="(item, index) in detail.userShop" :key="index">
          <!-- 客户售卖平台 -->
          <li class="flex2">
            <el-select v-model="item.shop_type" placeholder="选择售卖平台">
              <el-option v-for="item in options" :key="item.value" :label="item.value" :value="item.value">
              </el-option>
            </el-select>
          </li>
          <!-- 售卖店铺信息截图 -->
          <li @click="i = index">
            <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
              :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="item.shop_screen" :src="item.shop_screen" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </li>
          <!-- 操作 -->
          <li>
            <el-button size="small" type="success" class="dark" @click="del(index)">{{ $t("message.delete") }}</el-button>
          </li>
        </ul>
        <div class="noData" v-if="detail.userShop == false">暂无数据</div>
        <!-- 添加 -->
        <div class="btn">
          <el-button size="small" type="success" @click="add">{{
            $t("message.add")
          }}</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
      i: 0,
      options: [
        { value: "亚马逊" },
        { value: "乐天" },
        { value: "雅虎" },
        { value: "其他" },
      ],
    };
  },
  computed: {},
  methods: {
    add() {
      this.detail.userShop.push({
        shop_type: "",
        shop_screen: "",
      });
    },
    del(i) {
      this.detail.userShop.splice(i, 1);
    },
    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";

      if (!isJPG && !isPNG) {
        this.$message.r("上传图片只能是 JPG和PNG 格式!");
        this.loading = false;
      }
      return isJPG || isPNG;
    },
    //添加修改图片
    handleAvatarSuccess(file) {
      this.detail.userShop[this.i].shop_screen = file.data;
      this.$forceUpdate();
    },
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        list: this.detail.userShop,
      };
      this.$api.clienteleApi.setClientShop(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.table {
  background: #f8f8f8;
  border-radius: 8px;
  padding: 24px;

  ul {
    padding: 20px 0;
  }

  li {
    margin-right: 30px;

    &:nth-last-child(1) {
      margin: 0;
    }
  }

  .flex2 {
    flex: 2;
  }
}

.noData {
  text-align: center;
  margin: 24px 0;
  font-size: 20px;
}

.btn {
  margin-top: 24px;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>